import React from 'react'
import LatinoTemplateDefault from 'src/components/template/la/'

export default (props) => {
  return (
    <LatinoTemplateDefault
      location={props.location}
      lang="en"
      market="latino"
      title="Watch live LaLiga games"
      tagline={
        <>
          Stream them on ESPN Deportes{' '}
          <div className="desktop-line-break">from any device with Fubo</div>
        </>
      }
      networkSet="entertainmentLatino"
      noteLink="/la/la-liga-es-on-espn-deportes/"
      poster="https://assets-imgx.fubo.tv/marketing/lp/images/posters/LaLiga_Ver1_Web.jpg"
      posterMobile="https://assets-imgx.fubo.tv/marketing/lp/images/posters/LaLiga_Ver1_Mobile.jpg"
    />
  )
}
